import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { COLORS } from '../../../shared/colors';

export enum SnackbarType {
  INFORMATION,
  SUCCESS,
  WARNING,
  ERROR,
}

@Injectable()
export class SnackbarService {

  private snackbarQueue = [];
  private timeout;

  private _snackbarOptions = new Subject<any>();
  snackbarOptionsObservable = this._snackbarOptions.asObservable();

  constructor() {
  }

  /**
   * Adds a snackbar message to queue
   * @param {SnackbarType} type      SnackbarType (INFORMATION, SUCCESS, WARNING, ERROR)
   * @param {string} message         Message that should be displayed
   * @param {number} [duration=3000] Duration of message display (optional)
   */
  public add(type: SnackbarType, message: string, duration = 3000) {
    const snackbarOptions = {
      type: type,
      message: message,
      visible: false,
      duration: isNaN(duration) || duration <= 0 ? 3000 : duration,
      color: '',
      icon: '',
    };

    switch (snackbarOptions.type) {
      default:
      case SnackbarType.INFORMATION:
        snackbarOptions.color = COLORS.main.signalColorInfo.hex;
        snackbarOptions.icon = 'information';
        break;
      case SnackbarType.SUCCESS:
        snackbarOptions.color = COLORS.main.signalColorSuccess.hex;
        snackbarOptions.icon = 'success';
        break;
      case SnackbarType.WARNING:
        snackbarOptions.color = COLORS.main.signalColorWarning.hex;
        snackbarOptions.icon = 'warning';
        break;
      case SnackbarType.ERROR:
        snackbarOptions.color = COLORS.main.signalColorError.hex;
        snackbarOptions.icon = 'error';
        break;
    }

    this.snackbarQueue.push(snackbarOptions);

    if (this.snackbarQueue.length === 1) {
      this.openNextSnackbarItem();
    }
  }

  /**
   * Display next item in queue
   */
  private openNextSnackbarItem() {
    if (this.snackbarQueue.length > 0) {
      this.snackbarQueue[0]['visible'] = true;

      this._snackbarOptions.next(this.snackbarQueue[0]);
    }
  }

  /**
   * Dismiss message and trigger next item in queue
   */
  public dismiss() {
    this.snackbarQueue[0]['visible'] = false;

    this._snackbarOptions.next(this.snackbarQueue[0]);

    // Show next message after old one is hidden
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      // Remove first element of queue
      this.snackbarQueue.shift();

      this.openNextSnackbarItem();
    }, 250);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/snackbar/snackbar.service.ts